// Shipped with the application on the VPS; never uploaded to Drive.
export const TEAM_AVATARS = [
  { id: 'team-01', label: 'Cabello despeinado' },
  { id: 'team-02', label: 'Cabello borgoña' },
  { id: 'team-03', label: 'Mamá con bebé' },
  { id: 'team-04', label: 'Cabello corto rizado' },
  { id: 'team-05', label: 'Gorra negra' },
  { id: 'team-06', label: 'Rizos y lentes' },
  { id: 'team-07', label: 'Lentes y bigote' },
  { id: 'team-08', label: 'Barba y lentes' },
  { id: 'team-09', label: 'Gorra y barba' },
  { id: 'team-10', label: 'Cabello liso y lentes' },
];
export const teamAvatarPath = id => TEAM_AVATARS.some(a => a.id === id) ? `/api/tv/avatars/${id}.png` : null;
export function validateTeamAvatar(value) {
  if (value === null || value === '' || value === undefined) return null;
  if (!TEAM_AVATARS.some(a => a.id === value)) throw Object.assign(new Error('Selecciona un avatar del equipo válido.'), { status: 400 });
  return value;
}
